import { Directive, ElementRef, EventEmitter, OnInit, Output } from "@angular/core";

@Directive({
	selector: "[accessibleElement]",
	standalone: false
})
export class EngageAccessibleElementDirective implements OnInit {
	@Output() public addAccessibleElement: EventEmitter<ElementRef> = new EventEmitter<ElementRef>();
	constructor(private el: ElementRef) {}

	ngOnInit(): void {
		this.addAccessibleElement.emit(this.el.nativeElement);
	}
}
